// FIXME / Note: we are not using tools.isObject due to cycling dependencies
// tools => logger => globals => mock
const isObject = (val) => typeof val === 'object' && !Array.isArray(val) && val !== null;

/**
 * `uri` mocks Imperia's Util.uri implementation
 * see lib/Imperia/share/htdocs/imperia/js/lib/util.js
 * @param {*} path
 * @param {*} params
 * @returns
 */
export function uri(path, params) {
  const url = new URL(`http://localhost:2404/imp${path}`);
  if (isObject(params)) {
    Object.entries(params).forEach(([name, value]) => {
      url.searchParams.append(name, value);
    });
  }
  return url.toString();
}

export function mockI() {
  const mock = {
    Util: {
      uri,
    },
    settings: {
      user: { group_id: '1', user_id: '1' },
      system: {
        // header_ts: '1605101327',
        menu_ts: Date.now(),
        prefix: '/imp',
        // system_id: '25e1e978-906a-7475-8342-b84054f00b21',
      },
      acl: {
        // ts
        '/data/ts/tag/create': 1,
        '/data/ts/tag/delete': 1,
        '/data/ts/realm/create': 1,
        '/data/ts/realm/delete': 1,
        '/data/ts/tag/recommend': 1,
        '/document/browser': 1,
        // iql
        '/data/iql/filters': 1,

        // old style
        iql_filters: { save_filter: 1, delete_filter: 1 },
        ts: {
          create_realm: 1,
          create_tag: 1,
          delete_realm: 1,
          delete_tag: 1,
          recommend_tag: 1,
          show_tag: 1,
        },
      },
    },
  };
  window.I = window.I || mock;
}

export default {};
